import { Description } from '@repo/ui';

import LoaderAnimation from '@/assets/img/loader-animation.svg';

const LoadingContent = () => {
  return (
    <section className="px-8 py-spacious-medium">
      <Description className="p-6" title={'국세청 관련 자료를\n확인하고 있어요'} graphic={<LoaderAnimation width={80} height={80} />} />
    </section>
  );
};

export default LoadingContent;
